import normalizer from '@cordel/helpers/form/schema';

import {
  ALWAYS_VISIBLE,
  FILTERS,
} from './sections';

import {
  SEARCH,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [FILTERS]: {},
    },

    fields: {
      [SEARCH]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'input',
        label: 'Pesquisar',
        labelless: true,
        placeholder: 'Pesquisar...',
        size: 12,
        icon: 'search',
      },
    },
  });
}
